export enum ExamDeliveryMethod {
  OnlineProctored = 'online-proctored',
  OnsiteProctored = 'onsite-proctored',
  NonProctored = 'non-proctored',
}
